export default "__VITE_ASSET__YSRpWbLG__"